import { StringHelper } from "./StringHelper";

export class HtmlAttributesUtil {

    /**
     * Returns attribute as boolean
     *
     * @param node
     * @param attributeName
     * @param defaultValue
     */
    static getAttributeAsBoolean(node: HTMLElement, attributeName: string, defaultValue: boolean): boolean {
        if (!node || !attributeName) {
            return defaultValue;
        }
        const attribute = node.getAttribute(attributeName);
        if (!attribute) {
            return defaultValue;
        }
        const value = StringHelper.trim(attribute.toLocaleLowerCase());
        if (value === "true") {
            return true;
        } else if (value === "false") {
            return false;
        }
        return defaultValue;
    }

    /**
     * Returns attribute value as number
     *
     * @param node
     * @param attributeName
     * @param defaultValue
     */
    static getAttributeAsNumeric(node: HTMLElement, attributeName: string, defaultValue: number): number {
        if (!node || !attributeName) {
            return defaultValue;
        }
        const value = Number(node.getAttribute(attributeName));
        if (!value) {
            return defaultValue;
        }
        const valueAsNumber = Number(value);
        if (!isNaN(value)) {
            return value;
        } else {
            return defaultValue;
        }
    }

    /**
     * Returns attribute as text, default value will be return in case attribute is null nor "null"
     * @param node
     * @param attributeName
     * @param defaultValue
     */
    static getAttributeAsText(node: HTMLElement, attributeName: string, defaultValue: string): string {
        if (!node || !attributeName) {
            return defaultValue;
        }
        const value = node.getAttribute(attributeName);
        return (value && value !== "null") ? value : defaultValue;
    }

    /**
     * Returns attribute as array, default value will be return in case attribute is null nor "null"
     * @param node
     * @param attributeName
     * @param defaultValue
     */
    static getAttributeAsArray(node: HTMLElement, attributeName: string, defaultValue: any): string[] {
        if (!node || !attributeName) {
            return defaultValue;
        }
        const value = node.getAttribute(attributeName);
        return (value && value !== "null") ? value.split(",") : defaultValue;
    }
}